
export class ShipmentBoxDetails {
    boxId: string;
    sender: string;
    shipmentStatus: string;
    shipmentId: string;
    httpStatus: number;
    title: string;
    message: string;
    allBoxRecevied: boolean;
}

export class ShipmentBoxReception {
   boxId: string;
   sender: string;
   shipmentId: string;
   lab: string;
   puid: string;	
   allBoxRecevied: boolean;
}